<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span> Card Payments Built for Business</div>
            <div class="banner_tips mt-40 fw-300">Secure, efficient card payments powered by intelligent routing and modern infrastructure.</div>
            <router-link to="contact-us"><span class=" pointer color1 py-10 px-20 border-default mt-20 fs-f20 bg_3 dis-i-b" >Get Started</span></router-link>
            
          </div>
       </div>
    </div>


    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color1">Unified Reporting & Insights</div>
            <div class="title_tag color1">Gain full visibility into your payment operations with CorelinkPay's centralized reporting system.</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb3.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Optimized Routing</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Routes payments by location, card type, and transaction details for maximum efficiency.</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb4.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Higher Conversions</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Streamlined checkout reduces drop-offs and increases revenue.</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb5.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Cost Efficiency</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Smart routing minimizes fees and saves money.</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb6.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Fraud Prevention</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Real-time AI risk analysis reduces chargebacks while maintaining high approval rates.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="page_title_bg pt-60 pb-60" >
        <div class="page_width " >
           <div class="page_title">
            <div class="title_name color1">Advanced Risk Management</div>
            <div class="title_tag color1">Protect your business with AI-powered risk assessment and fraud detection.</div>
          </div>
          <div class="grid mt-60">
            <div class="grid_md_4 grid_xs_12 grid_sm_12">
              <div class="flex_col_center py-20">
                <img src="../../assets/image/dz4.png" alt="" class="h-84px w-a">
                <div class="fs-30 mt-20 color1 fw-300">Analyzes 50+ data points instantly</div>
              </div>
            </div>
            <div class="grid_md_4 grid_xs_12 grid_sm_12">
              <div class="flex_col_center py-20">
                <img src="../../assets/image/dz5.png" alt=""  class="h-84px w-a">
                <div class="fs-30 mt-20 color1 fw-300">AI precision with human oversight</div>
              </div>
            </div>
            <div class="grid_md_4 grid_xs_12 grid_sm_12">
              <div class="flex_col_center py-20">
                <img src="../../assets/image/dz6.png" alt=""  class="h-84px w-a"> 
                <div class="fs-30 mt-20 color1 fw-300">Safe payments, high approval rates</div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
    </div>
   <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color1">Global Reach, Local Precision</div>
            <div class="title_tag color1">Worldwide coverage with support for local payment preferences.</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon mb-10">
                          <div class="flex">
                            <div class="flex_item" v-for="(i,index) in gjList" :key="index"><img :src="i.icon" alt=""></div>
                            <div class="flex_item fs-12 color1 flex_center">55+</div>
                          </div>
                        </div>
                        <div class="half_title color1">55+ Countries</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">High approval rates in regions like North America, Europe, Asia, and more.</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon mb-10">
                         <div class="flex">
                            <div class="flex_item" v-for="(i,index) in zfList" :key="index"><img :src="i.icon" alt=""></div>
                            <div class="flex_item fs-12 color1 flex_center">100+</div>
                          </div>
                        </div>
                        <div class="half_title color1">100+ Currencies</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Accept payments in global currencies to expand your market.</div>
                    </div>
                </div>
                
              </div>
          </div>
        </div>
      </div>
    </div>
   <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color1">Flexible Payment Options</div>
            <div class="title_tag color1">Single and dual-message systems tailored to your business needs.</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb7.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Instant Charges</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Authorize and process in one step for fast checkout. Ideal for high-speed transactions.</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb8.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Delayed Charges</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Authorize first, reserve funds, process later. Enhanced security for high-value transactions.</div>
                    </div>
                </div>
               
              </div>
          </div>
        </div>
      </div>
    </div>
   
    <div class="container  "> 
      <div class="page_title_bg page_top py-50" >
        <div class="page_width " >
         
           <div class="cate_container">
             <div class="page_title ">
                <div class="title_name">Features That Scale</div>
                <div class="title_tag">Tools designed to simplify and enhance your payment operations.</div>
              </div>
             <div class="grid grid_gap_none mt-40" >
              <div class="grid_md_12 grid_xs_12 grid_sm_12">
                <div class="item_group h-100p" >
                  <div class="item_inner h-100p">
                    <div class="group_half flex_col_center h-100p w-100p">
                      <div class="half_container  flex_col_start " >
                         <div class="half_text flex_center_start mt-10">
                          <img src="../../assets/image/g.png" alt="" class="w-30px h-30px mr-30"> 90%+ approval rates: Secure, reliable gateway for successful transactions
                         </div>
                         <div class="half_text flex_center_start mt-20">
                          <img src="../../assets/image/g.png" alt="" class="w-30px h-30px mr-30"> Universal platform support: Integrates with all major tech stacks
                         </div>
                         <div class="half_text flex_center_start mt-20">
                          <img src="../../assets/image/g.png" alt="" class="w-30px h-30px mr-30">Simple API integration: Manage keys and configurations easily
                         </div>  
                         <div class="half_text flex_center_start mt-20">
                          <img src="../../assets/image/g.png" alt="" class="w-30px h-30px mr-30">Real-time dashboard: Monitor, manage, and analyze transactions
                         </div>
                         
                      </div>   
                      
                    </div>
                  </div>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color1">Unified Reporting & Insights</div>
            <div class="title_tag color1">Full visibility into your payment operations with centralized reporting.</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb9.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Track Performance</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Monitor payment trends and success rates.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb10.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Holistic Analytics</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Real-time Pay & Biz Performance Insights</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb11.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Unified Dashboard</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Manage All Pay Activities via 1 Intuitive Platform</div>
                    </div>
                </div>
               
              </div>
          </div>
        </div>
      </div>
    </div>


  
  </div>
</template>

<script>

import icon1 from '../../assets/image/zftb1.png'
import icon2 from '../../assets/image/zftb2.png'
import icon3 from '../../assets/image/zftb3.png'
import icon4 from '../../assets/image/zftb4.png'
import icon5 from '../../assets/image/zftb5.png'


import gj1 from '../../assets/image/gj1.png'
import gj2 from '../../assets/image/gj2.png'
import gj3 from '../../assets/image/gj3.png'
import gj4 from '../../assets/image/gj4.png'
import gj5 from '../../assets/image/gj5.png'
export default {
 
    data(){
        return{
           tab_active:'1', 
           zfList:[
            {icon:icon1},{icon:icon2},{icon:icon3},{icon:icon4},{icon:icon5},
           ],
           gjList:[
            {icon:gj1}, {icon:gj2}, {icon:gj3}, {icon:gj4}, {icon:gj5},
           ]
          
           
        }
    },
     created () {
  
    
    },
    mounted(){
         
    },
    methods:{
      
    },
    beforeDestroy(){
       
    }
}
</script>

<style lang="scss" scoped>
.grid_five{
    display: grid;
    grid-template-columns: 2fr 3fr 2fr;
   
    .item_group{
        .item_inner{
            .group_half{
                
                .half_text{
               
                }
            }
        }
        
    }
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}
.ad_tab{
    font-size: 26px;
    padding:20px 0;
    transition: border 0.4s ease-in-out,color 0.4s ease-in-out;
    border-bottom:6px solid #E1E2E5;
    
}
.ad_tab_active{
     border-bottom:6px solid $theme_color3;
     color:$theme_color3;
}
.tab_container{
    background-image:url( ../../../public/bg/glbg.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    display: block;
}
// .bg_3{
//     background-image:url( ../../../public/bg/bg3.png);
//     background-size: 100% 100%;
//     background-position: center center;
//     background-repeat: no-repeat;
// }
.custom-scroll {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;;
    
}
.scroll-content {
    display: flex;
    animation: gridScroll 30s linear infinite;

}
.rescroll-content {
    display: flex;
    animation: gridReScroll 30s linear infinite;
}
.country{
    padding:6px 10px;
    background: #262D4C;
    border-radius: 21px 21px 21px 21px;
    border: 1px solid #003CFF;
    align-items: baseline;
    opacity: 0.9;
    
    >img{
        width: auto;
       
    }
    margin:0 10px;
}
.flex_item{
  width: 40px;
  height: 40px;
  position: relative;
  background: #272932;
  border-radius: 50%;

  >img{
    width:100%;
    height: 100%;
  }
}
.flex_item + .flex_item{
  margin-left:-12px;
}
@keyframes gridScroll {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}
@keyframes gridReScroll {
    0% {
        transform: translateX(-50%);
    }
    100% {
        transform: translateX(0);
    }
}

.zf_tab{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin:0 14px;
}


@media screen and (max-width:991px){
    .grid_five{
      grid-template-columns:1fr;
      .item_group{
        padding:0;
      }
      .item_inner{
        // display: flex;
        .group_half{
           
            padding:20px 10px;
        }
      }
    }
    .ad_tab{
        font-size: 14px;
    }
}
</style>